import React, { useState } from "react";
import { RightOutlined } from "@ant-design/icons";

interface PayoutDisclosureProps {
	title: string;
	children: React.ReactNode;
}

/**
 * A show/hide section for the payout lists. Deliberately not antd's Collapse: a global rule in
 * components/Header.css (meant for the dark mobile menu) forces every Collapse header in the app
 * to white text with no padding, which made these titles invisible inside the white modal.
 */
const PayoutDisclosure = ({ title, children }: PayoutDisclosureProps) => {
	const [open, setOpen] = useState(false);

	return (
		<div className="rounded-lg border border-gray-200">
			<button
				type="button"
				aria-expanded={open}
				onClick={() => setOpen((isOpen) => !isOpen)}
				className="flex w-full items-center gap-2 rounded-lg px-4 py-3 text-left text-[15px] font-medium text-gray-800 hover:bg-gray-50"
			>
				<RightOutlined
					className={`text-xs text-gray-500 transition-transform ${
						open ? "rotate-90" : ""
					}`}
				/>
				{title}
			</button>
			{open && (
				<div className="border-t border-gray-200 p-2">{children}</div>
			)}
		</div>
	);
};

export default PayoutDisclosure;
